var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.surveyIndex || !_vm.surveyIndex.surveyInfoRead)?_c('survey-info'):(_vm.showAward)?_c('award',{attrs:{"survey":_vm.survey}}):_c('survey',{attrs:{"survey":_vm.survey},on:{"finished":function($event){return _vm.finished()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }